import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularTokenService } from 'angular-token';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/utils/loader.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth.service';
import { SharedServiceService } from 'src/app/shared/services/shared-service.service';
import { AdminService } from 'src/app/admin/admin.service';
import { DomSanitizer } from '@angular/platform-browser';

enum AppIds {
  PARTNER_APP = "pZfxJHkfoq"
}

@Component({
  selector: 'app-login-way',
  templateUrl: './login-way.component.html',
  styleUrls: ['./login-way.component.scss']
})
export class LoginWayComponent implements OnInit {
  public tOneUrl = environment.tOneUrl + '/auth/';
  public tOneAdminUrl = environment.tOneAdminUrl;
  public isTokenVerified = true;
  staticAssetsDomain = environment.truventorStaticAssetCdnDomain
  showHealthCheckButton = false; // New property to control button visibility
  token: string = '';
  engage_token: any;
  iframeEndpoint: string;

  constructor(
    private loaderService: LoaderService
    , private tokenService: AngularTokenService
    , private toastr: ToastrService
    , public router: Router
    , private authservice: AuthService
    , public activeRoute: ActivatedRoute,
    private sharedService: SharedServiceService,
    private adminService: AdminService,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.subscribeToObservables();
    // Check query params when component initializes
    this.activeRoute.queryParams.subscribe(params => {
      this.showHealthCheckButton = params['healthcheck'] === 'true';
    })
    //localStorage.clear();
    this.loaderService.display(true);
    this.isTokenVerified = true;
    this.token = this.activeRoute.snapshot.queryParamMap.get('auth');
    if (this.token) {
      this.authservice.signin(this.token).subscribe(
        res => {
          console.log(res);
          localStorage.setItem('token', this.token);
          localStorage.setItem('id', res['data']['id']);
          localStorage.setItem('email', res['data']['email']);
          localStorage.setItem('account_type_id', res['data']['account_type_id']);
          localStorage.setItem('has_onboarded', res['data']['has_vendor_onboarded']);
          localStorage.setItem('role_name', res['data']['role']['name']);
          localStorage.setItem('is_approved', res['data']['is_vendor_approved']);
          localStorage.setItem('name', res['data']['name']);
          localStorage.setItem('avatar', res['data']['user_avatar']['url']);
          localStorage.setItem('isRMS', res['data']['isRMS']);
          if (localStorage.getItem('is_approved') == "true") {
            this.router.navigate(['/admin/dashboard']);
          }
          else if (localStorage.getItem('has_onboarded') == "false") {
            this.router.navigate(['/onboarding']);
          }
          else {
            this.router.navigate(['/onboarding/submitted']);
          }
          this.loaderService.display(false);
          this.sharedService.engage_token = this.token;
          this.getDefaultChatId();
          this.toastr.success("Logged in successfully.", 'Success');

          this.authservice.getEngageToken(res['data']['id']).subscribe(
            (res: any) => {
              console.log(res)
              localStorage.setItem('engage_auth_code', res.engage_auth_code)
            },
            err => {
              console.log(err)
            }
          );
        }, err => {
          this.loaderService.display(false);
          this.isTokenVerified = false;
          if (err.error.message) {
            let msg = err.error.message;
            if (err.error.message == 'This email is not registered.', 'Error') {
              this.toastr.error(msg, 'Error');
            } else {
              this.toastr.error(msg, 'Error');
            }
          } else {
            for (let i in err.error.errors) {
              this.toastr.error(err.error.errors[i]);
            }
          }
        }
      );
    }
    else {
      this.isTokenVerified = false;
      this.loaderService.display(false);
    }
  }

  subscribeToObservables() {
    // Subscribe to observables to get real-time updates
    this.sharedService.engage_token$.subscribe((engage_token) => {
      this.engage_token = engage_token;
    });

    this.sharedService.iframeEndpoint$.subscribe((iframeEndpoint) => {
      this.iframeEndpoint = iframeEndpoint;
    });
  }

  getDefaultChatId(): void {
    this.adminService.createDefaultChat().subscribe(
      (res: any) => {
        if (res?.data?.[0]?.chatID) {
          // Use the shared service's setter to set the chatID
          this.sharedService.chatID = res.data[0].chatID;
          localStorage.setItem('ai-chat-id', res?.data?.[0]?.chatID);
          // Generate the safe URL
          this.sharedService.engageUrl = this.getSafeUrl(
            res.data[0].chatID,
            this.engage_token,
            this.iframeEndpoint
          );
        } else {
          console.warn("Chat ID not found in the response.");
        }
      },
      (err) => {
        // Clear the chatID in the shared service on error
        this.sharedService.chatID = '';
        console.error(
          "Failed while finding chat room for the referenceID!",
          err
        );
      }
    );
  }

  getSafeUrl(chat_id: any, engage_token: string, endpoint: string) {
    if (chat_id) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        environment.safeUrl +
        endpoint +
        chat_id +
        "?token=" +
        engage_token +
        "&iframe=true"
      );
    } else {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        environment.safeUrl +
        endpoint +
        "?token=" +
        engage_token +
        "&iframe=true"
      );
    }
  }

  checkForAuth() {
    if (window.location !== window.parent.location) {
      window.addEventListener('message', function (event) {
        if (event.origin === environment.tOneUrl) {
          if (event.data) {
            localStorage.setItem('auth_details', event.data);
          }
        }
      });
    }
    else {
      let auth_details = JSON.parse(localStorage.getItem('auth_details'));
      if (auth_details != null && (auth_details['data'] != undefined && auth_details['data'] != null)) {
        this.tokenService.signIn({
          login: auth_details['data'][0]['user']['email'],
          password: auth_details['data'][0]['user']['password']
        }).subscribe(
          res => {
            // console.log(res);   
            localStorage.setItem('id', res['body']['data']['id']);
            localStorage.setItem('email', res['body']['data']['email']);
            localStorage.setItem('account_type_id', res['body']['data']['account_type_id']);
            localStorage.setItem('has_onboarded', res['body']['data']['has_vendor_onboarded']);
            localStorage.setItem('role_name', res['body']['data']['role']['name']);
            localStorage.setItem('is_approved', res['body']['data']['is_vendor_approved']);
            localStorage.setItem('name', res['body']['data']['name']);
            localStorage.setItem('avatar', res['body']['data']['user_avatar']['url']);
            localStorage.setItem('isRMS', res['data']['isRMS']);
            if (localStorage.getItem('is_approved') == "true") {
              this.router.navigate(['/admin/dashboard']);
            }
            else if (localStorage.getItem('has_onboarded') == "false") {
              this.router.navigate(['/onboarding']);
            }
            else {
              this.router.navigate(['/onboarding/submitted']);
            }
            this.loaderService.display(false);
            this.toastr.success("Logged in successfully.", 'Success');

            this.authservice.getEngageToken(res['body']['data']['id']).subscribe(
              (res: any) => {
                console.log(res)
                localStorage.setItem('engage_auth_code', res.engage_auth_code)
              },
              err => {
                console.log(err)
              }
            );
          }, err => {
            this.loaderService.display(false);
            if (err.error.message) {
              let msg = err.error.message;
              if (err.error.message == 'This email is not registered.', 'Error') {
                this.toastr.error(msg, 'Error');
              } else {
                this.toastr.error(msg, 'Error');
              }
            } else {
              for (let i in err.error.errors) {
                this.toastr.error(err.error.errors[i]);
              }
            }
          }
        );
      }
      localStorage.removeItem('auth_details');
    }
  }

  redirectToLogin() {
    const loginUrl = `${this.tOneUrl}login?app_id=${AppIds.PARTNER_APP}&redirect_uri=${this.getBaseUrl()}`;
    window.location.href = loginUrl;
  }

  redirectToSignup() {
    const loginUrl = `${this.tOneUrl}register?app_id=${AppIds.PARTNER_APP}&redirect_uri=${this.getBaseUrl()}`;
    window.location.href = loginUrl;
  }

  redirectOrgAdminLogin() {
    const loginUrl = `${this.tOneAdminUrl}`;
    window.location.href = loginUrl;
  }

  getBaseUrl() {
    const url = new URL(window.location.href);
    const baseUrl = `${url.protocol}//${url.hostname}/`;
    return encodeURIComponent(baseUrl);
  }

  getAssetLink(path: string) {
    return path;
    // return `${this.staticAssetsDomain}${path}` //: Uncomment after activating front-door
  }

  // New method to test API health
  testApiHealth(): void {
    this.authservice.testApiHealth(this.token).subscribe(
      res => {
        if (res) {
          this.toastr.success("API server healthy", 'Success');
        }
      },
      err => {
        this.toastr.error('API server unhealthy');
      }
    );
  }
}